<div class="bottom-menu md:hidden">
  <div class="bottom-menu__row">
    <a href="/" class="bottom-menu__link">
      <div class="bottom-menu__icon">
        <app-ui-icon [name]="'icon-house'" [width]="21" [height]="19"></app-ui-icon>
      </div>
      <span class="bottom-menu__text">Главная</span>
    </a>
    <a href="/favorites" class="bottom-menu__link">
      <div class="bottom-menu__icon">
        <app-ui-icon [name]="'icon-favorite'" [width]="20" [height]="18"></app-ui-icon>
      </div>
      <span class="bottom-menu__text">Избранное</span>
    </a>
    <a href="/razmestit-object" class="bottom-menu__link">
      <div class="bottom-menu__icon">
        <app-ui-icon [name]="'icon-plus'" [width]="21" [height]="20"></app-ui-icon>
      </div>
      <span class="bottom-menu__text">Разместить</span>
    </a>
    <a href="#" class="bottom-menu__link">
      <div class="bottom-menu__icon">
        <app-ui-icon [name]="'icon-message'" [width]="20" [height]="20"></app-ui-icon>
      </div>
      <span class="bottom-menu__text">Сообщения</span>
    </a>
    <a href="https://client.ndv.ru/authentication/start" class="bottom-menu__link">
      <div class="bottom-menu__icon">
        <app-ui-icon [name]="'icon-profile'" [width]="25" [height]="24"></app-ui-icon>
      </div>
      <span class="bottom-menu__text">Профиль</span>
    </a>
  </div>
</div>
